import type {IConsentItem} from "../../application/types/financial_application";
import type {IConsentTemplate} from "../types";

export const buildConsentRecords = (formConsents: Record<string, boolean>, defaultConsents: IConsentTemplate[]): IConsentItem[] => [
    ...Object.entries(formConsents).map(([consent_template_id, state]) => ({consent_template_id, state})),
    ...defaultConsents.map((template) => ({consent_template_id: template.ulid, state: true}))
];
import type {IConsentItem} from "../../application/types/financial_application";
import type {IConsentTemplate} from "../types";

export const buildConsentRecords = (formConsents: Record<string, boolean>, defaultConsents: IConsentTemplate[]): IConsentItem[] => [
    ...Object.entries(formConsents).map(([consent_template_id, state]) => ({consent_template_id, state})),
    ...defaultConsents.map((template) => ({consent_template_id: template.ulid, state: true}))
];
